import { useEffect, useState } from "react";
import UserContxt from "./context/UserContext";
import Axios from "axios";
import SignIn from "./components/login/SignIn";
import SignUp from "./components/login/SignUp";
import Header from "./layout/Header";
import errorr from "./error/errorr";
import Loading from "./loading/Loading";
import "./App.css";
import Cart from "./components/cart/Cart";
import Home from "./components/Home";
import Oder from "./components/cart/Oder";
import { CartProvider } from "react-use-cart";
import ScrollToTop from "./ScrollToTop";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import { ServerProvider } from "./contex/ServerContext";
import Shop from "./components/shop/Shop";
import ItemDetails from "./components/ItemDetails/ItemDetails";
import Man from "./components/shop/Man";
import Woman from "./components/shop/Woman";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./layout/Footer";

import { API_URL } from "./constants";

function App() {
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    const checkLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");
      if (token === null) {
        localStorage.setItem("auth-token", "");
        token = "";
      }
      const url1 = `${API_URL}/api/user/tokenIsValied`;
      const tokenRes = await Axios.post(url1, null, {
        headers: { "x-auth-token": token },
      });
      if (tokenRes.data) {
        const url2 = `${API_URL}/api/admin/getUser`;
        const userRes = await Axios.get(url2, {
          headers: { "x-auth-token": token },
        });
        setUserData({
          token,
          user: userRes.data,
        });
      }
    };
    checkLoggedIn();

    setTimeout(() => setSpinner(false), 1000, <Loading />);
  }, []);

  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined,
  });

  return (
    <div className="App">
      {!spinner ? (
        <>
          <>
            <CartProvider>
              <BrowserRouter>
                <ServerProvider>
                  <UserContxt.Provider value={{ userData, setUserData }}>
                    <ScrollToTop />
                    <Header />
                    <div style={{ padding: "35px" }}></div>
                    <Switch>
                      <Route exact path="/" component={Home} />
                      <Route path="/SignUp" component={SignUp} />
                      <Route path="/SignIn" component={SignIn} />
                      <Route exact path="/cart" component={Cart} />
                      <Route exact path="/oder" component={Oder} />
                      <Route exact path="/shop" component={Shop} />
                      <Route exact path="/man" component={Man} />
                      <Route exact path="/woman" component={Woman} />
                      <Route exact path="/about" component={About} />
                      <Route exact path="/faq" component={Faq} />
                      <Route exact path="/contact" component={Contact} />
                      <Route
                        exact
                        path="/ItemDetails/:id"
                        component={ItemDetails}
                      />

                      <Route path="*" component={errorr}></Route>
                    </Switch>
                  </UserContxt.Provider>
                </ServerProvider>
                <Footer />
              </BrowserRouter>
            </CartProvider>
          </>
        </>
      ) : (
        <>
          <Loading />
        </>
      )}
    </div>
  );
}

export default App;
